const constants = {
  remove: "Quitar",
  select: "Seleccionar",
};
export default constants;
